import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';


// actions
import actions from '../../../actions/lexique';

// components
import Loader from '../../tools/loader/Loader';
import Header from '../lexique/Header';
import LexiqueResults from './lexiqueResults/LexiqueResults';

// Functions
import { getHelmetTags, getLoadingHelmetTags } from '../../tools/helmetHelpers';

// Styles
import './styles.scss';

class Lexique extends Component {
  constructor(props, { initialRender, customStore }) {
    super(props);
    const { fetchLexiqueTitle, fetchSeoData, slug } = props;
    if (initialRender) {
      fetchSeoData(slug, customStore);
      fetchLexiqueTitle(slug, customStore);
    }
  }
  componentDidMount() {
    const { seoData,
      lexiqueTitleContent,
      fetchSeoData,
      fetchLexiqueTitle,
      lexiqueResults,
      fetchLexiqueResults,
      slug,
    } = this.props;
    if (Object.keys(seoData).length === 0) {
      fetchSeoData(slug);
    }
    if (Object.keys(lexiqueTitleContent).length === 0) {
      fetchLexiqueTitle(slug);
    }
    if (lexiqueResults.length === 0) {
      fetchLexiqueResults();
    }
    if (window) {
      window.scrollTo(0, 0);
    }
  }
  render() {
    const {
      isLoading,
      isLoadingTitle,
      seoData,
      lexiqueTitleContent,
      lexiqueResults,
    } = this.props;
    const { t } = this.context;
    return (
      <div>
        {isLoadingTitle ? getLoadingHelmetTags(t) : getHelmetTags(t, seoData)}
        <div className="lexique">
          {!isLoadingTitle ? <Header titleContent={lexiqueTitleContent} /> : <Loader /> }
          {(!isLoading && !isLoadingTitle) ?
            <LexiqueResults lexiqueResults={lexiqueResults} /> : <Loader />}

        </div>
      </div>
    );
  }
}
Lexique.propTypes = {
  fetchSeoData: PropTypes.func.isRequired,
  fetchLexiqueTitle: PropTypes.func.isRequired,
  fetchLexiqueResults: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isLoadingTitle: PropTypes.bool.isRequired,
  lexiqueTitleContent: PropTypes.object.isRequired,
  lexiqueResults: PropTypes.array.isRequired,
  seoData: PropTypes.object.isRequired,
  slug: PropTypes.string.isRequired,
};

Lexique.contextTypes = {
  customStore: PropTypes.object,
  initialRender: PropTypes.bool,
  t: PropTypes.func,
};
function mapStateToProps(state) {
  return {
    isLoading: state.lexique.isLoading,
    isLoadingTitle: state.lexique.isLoadingTitle,
    seoData: state.lexique.seoData,
    lexiqueResults: state.lexique.lexiqueResults,
    lexiqueTitleContent: state.lexique.lexiqueTitleContent,
  };
}

export default connect(mapStateToProps, actions)(Lexique);



// WEBPACK FOOTER //
// ./src/app/components/pages/lexique/Lexique.js